import { Button } from "@fluentui/react-components";
import { memo, MouseEventHandler } from "react";

type ActionButtonsProps = {
  onUpdate: MouseEventHandler<HTMLButtonElement>;
  onReset: MouseEventHandler<HTMLButtonElement>;
  updateLabel: string;
  resetLabel: string;
  className: string;
  disabled?: boolean;
  secondBtnAppearance?: "outline" | "secondary";
  btnClassName?: string;
  haveWidth?: boolean;
};

export const ActionButtons = memo(
  ({
    onUpdate,
    onReset,
    updateLabel,
    resetLabel,
    className,
    secondBtnAppearance = "outline",
    disabled,
    btnClassName,
    haveWidth,
  }: ActionButtonsProps) => {
    return (
      <div className={className}>
        <Button
          className={btnClassName}
          type="submit"
          shape="rounded"
          appearance="primary"
          onClick={onUpdate}
          disabled={disabled}
        >
          {updateLabel}
        </Button>
        <Button
          style={haveWidth ? { width: "100%" } : undefined}
          shape="rounded"
          appearance={secondBtnAppearance}
          className={btnClassName}
          onClick={onReset}
        >
          {resetLabel}
        </Button>
      </div>
    );
  }
);
